import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '@radix-ui/themes/styles.css';
import './index.css';
import { exampleRepository } from '@/database/repositories/exampleRepository';

try {
  await exampleRepository.seedDatabaseIfEmpty({ force: true, days: 7 });
} catch (err) {
  console.warn('Seed data failed to load:', err);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
